import Controller from "./privateBusRequests.controller";
import template from "./privateBusRequests.html";

const privateBusRequests = {
  template,
  controller: Controller,
};

export default privateBusRequests;



// WEBPACK FOOTER //
// ./src/pages/privateBusRequests/privateBusRequests.component.js